import { BadgeCssClassStatusEnum } from "app/back-office/shared/enum/badge-css-class-status.enum.model";
import { GridColumn, GridColumnTypeEnum, StatusLabelsWithCssClass } from "app/back-office/shared/models/common/grid-settings.model";
import { CustomizationRequestStatusVMEnum } from "app/shared/enums/customization-request-status.enum";
import { ProductProjectTypeEnum } from "app/shared/enums/product-project-type.enum";

export enum crColumnsEnum {
  actions = 1,
  id = 2,
  name = 3,
  customer = 4,
  designer = 5,
  qty = 6,
  price = 7,
  lastDesignerNotification = 8,
  lastUpdate = 9,
  project = 10,
  status = 11
}

export class CrColumnsListItem {
  isVisible: boolean;
  id: crColumnsEnum;
  gridColumn: GridColumn;
  alwaysVisible?: boolean;
  /** Colonna esclusa per il ruolo CustomerGuest (niente prezzi) */
  hideToCustomerGuest?: boolean;
}

export const CrColumnsList: CrColumnsListItem[] = [
  {
    isVisible: false,
    id: crColumnsEnum.actions,
    gridColumn: new GridColumn({
      colId: crColumnsEnum.actions,
      name: '',
      prop: 'actions',
      type: GridColumnTypeEnum.actions,
      width: 30,
      checkable: false
    }),
    alwaysVisible: true
  },
  {
    isVisible: true,
    id: crColumnsEnum.id,
    gridColumn: new GridColumn({
      colId: crColumnsEnum.id,
      name: 'Id',
      prop: 'id',
      enableClickCell: true,
      width: 60,
      sortProp: 'Id',
      notificationDotProp: 'hasNotifications',
      hasNotificationDot: true,
      type: GridColumnTypeEnum.string,
      checkable: false
    }),
    alwaysVisible: true
  },
  {
    isVisible: true,
    id: crColumnsEnum.name,
    gridColumn: new GridColumn({
      colId: crColumnsEnum.name,
      name: 'TABLE.CUSTOMIZATION_REQUEST.COLUMN.NAME',
      prop: 'title',
      enableClickCell: true,
      minWidth: 130,
      sortProp: 'Title',
      checkable: false
    }),
    alwaysVisible: true
  },
  {
    isVisible: true,
    id: crColumnsEnum.customer,
    gridColumn: new GridColumn({
      colId: crColumnsEnum.customer,
      name: 'TABLE.CUSTOMIZATION_REQUEST.COLUMN.CUSTOMER',
      prop: 'customerName',
      enableClickCell: true,
      minWidth: 125
    })
  },
  {
    isVisible: true,
    id: crColumnsEnum.designer,
    gridColumn: new GridColumn({
      colId: crColumnsEnum.designer,
      name: 'Designer',
      prop: 'designerName',
      enableClickCell: true
    })
  },
  {
    isVisible: true,
    id: crColumnsEnum.qty,
    gridColumn: new GridColumn({
      colId: crColumnsEnum.qty,
      name: 'Qty',
      prop: 'productCount',
      type: GridColumnTypeEnum.number,
      width: 70,
      enableClickCell: true
    })
  },
  {
    isVisible: true,
    id: crColumnsEnum.price,
    gridColumn: new GridColumn({
      colId: crColumnsEnum.price,
      name: 'TABLE.CUSTOMIZATION_REQUEST.COLUMN.TOTAL_WHOLESALE',
      prop: 'wholesaleTotalPrice',
      type: GridColumnTypeEnum.price,
      currencyProp: 'currencyCode',
      width: 110,
      enableClickCell: true
    }),
    hideToCustomerGuest: true
  },
  {
    isVisible: true,
    id: crColumnsEnum.lastDesignerNotification,
    gridColumn: new GridColumn({
      colId: crColumnsEnum.lastDesignerNotification,
      name: 'TABLE.CUSTOMIZATION_REQUEST.COLUMN.LAST_DESIGNER_NOTIFICATION',
      prop: 'lastDesignerReadyNotificationSentAt',
      type: GridColumnTypeEnum.date,
      enableClickCell: true,
      sortProp: 'LastDesignerReadyNotificationSentAt'
    })
  },
  {
    isVisible: true,
    id: crColumnsEnum.lastUpdate,
    gridColumn: new GridColumn({
      colId: crColumnsEnum.lastUpdate,
      name: 'TABLE.CUSTOMIZATION_REQUEST.COLUMN.LAST_UPDATE',
      prop: 'lastMovementDate',
      type: GridColumnTypeEnum.date,
      enableClickCell: true,
      sortProp: 'lastMovementDate'
    })
  },
  {
    isVisible: true,
    id: crColumnsEnum.project,
    gridColumn: new GridColumn({
      colId: crColumnsEnum.project,
      name: 'TABLE.CUSTOMIZATION_REQUEST.COLUMN.PROJECT',
      prop: 'projectType',
      type: GridColumnTypeEnum.status,
      width: 90,
      enableClickCell: true,
      statusLabelsWithCssClass: [
        new StatusLabelsWithCssClass({
          cssClass: BadgeCssClassStatusEnum.info,
          enumValue: ProductProjectTypeEnum.Subli,
          label: 'STATUS.SUBLI'
        }),
        new StatusLabelsWithCssClass({
          cssClass: BadgeCssClassStatusEnum.warning,
          enumValue: ProductProjectTypeEnum.Evo,
          label: 'STATUS.EVO'
        })
      ],
      statusFallbackLabel: '-'
    })
  },
  {
    isVisible: true,
    id: crColumnsEnum.status,
    gridColumn: new GridColumn({
      colId: crColumnsEnum.status,
      name: 'TABLE.CUSTOMIZATION_REQUEST.COLUMN.STATUS',
      prop: 'customStatus',
      statusLabelsWithCssClass: [
        new StatusLabelsWithCssClass({
          cssClass: BadgeCssClassStatusEnum.info,
          enumValue: CustomizationRequestStatusVMEnum.DraftWithoutNotification,
          label: 'STATUS.DRAFT_WITHOUT_NOTIFICATION'
        }),
        new StatusLabelsWithCssClass({
          cssClass: BadgeCssClassStatusEnum.secondary,
          enumValue: CustomizationRequestStatusVMEnum.DraftWithNotification,
          label: 'STATUS.DRAFT_WITH_NOTIFICATION'
        }),
        new StatusLabelsWithCssClass({
          cssClass: BadgeCssClassStatusEnum.warning,
          enumValue: CustomizationRequestStatusVMEnum.ApprovedByRequestingUser,
          label: 'STATUS.APPROVED_BY_REQUESTING_USER'
        }),
        new StatusLabelsWithCssClass({
          cssClass: BadgeCssClassStatusEnum.warning,
          enumValue: CustomizationRequestStatusVMEnum.GraphicallyApproved,
          label: 'STATUS.APPROVED_GRAPHICALLY'
        }),
        new StatusLabelsWithCssClass({
          cssClass: BadgeCssClassStatusEnum.success,
          enumValue: CustomizationRequestStatusVMEnum.CommerciallyApproved,
          label: 'STATUS.APPROVED'
        }),
        new StatusLabelsWithCssClass({
          cssClass: BadgeCssClassStatusEnum.danger,
          enumValue: CustomizationRequestStatusVMEnum.Rejected,
          label: 'STATUS.REJECTED'
        }),
        new StatusLabelsWithCssClass({
          cssClass: BadgeCssClassStatusEnum.primary,
          enumValue: CustomizationRequestStatusVMEnum.Ordered,
          label: 'STATUS.ORDERED'
        })
      ],
      type: GridColumnTypeEnum.status,
      width: 200,
      enableClickCell: true
    })
  }
];
